/**
 * Fenetre de confirmation des favoris (app Swishlist).
 *
 * L'app affiche « Log in to keep your wishlist and access it anytime. » en texte
 * simple, sans lien. On le rend cliquable vers la page de connexion.
 *
 * Le gabarit de la fenetre est injecte a l'execution et une nouvelle fenetre est
 * creee a chaque ajout : on observe donc le document plutot que d'agir une seule
 * fois au chargement. La mise en forme, elle, reste dans base.css.
 */
(() => {
  const MESSAGE = '.st-product-toast_sub-message';
  const MARK = 'data-theme-login-link';

  function loginUrl() {
    const root = window.Shopify?.routes?.root || '/';
    return `${root.replace(/\/$/, '')}/account/login`;
  }

  function patch(el) {
    if (el.hasAttribute(MARK)) return;
    const label = el.textContent.trim();
    if (!label) return;
    // Deja transforme en lien par l'app : on n'y touche pas.
    if (el.querySelector('a')) {
      el.setAttribute(MARK, '');
      return;
    }

    const link = document.createElement('a');
    link.href = loginUrl();
    link.className = 'st-toast-login-cta';
    link.textContent = label;

    el.textContent = '';
    el.appendChild(link);
    el.setAttribute(MARK, '');
  }

  function scan() {
    document.querySelectorAll(MESSAGE).forEach(patch);
  }

  let queued = false;
  function scheduleScan() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      scan();
    });
  }

  function start() {
    scan();
    new MutationObserver(scheduleScan).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
